import React from 'react';
import { Reveal } from './Reveal';
import { useContent } from '../content/ContentProvider';
import '../styles/glass.css';

export const Values: React.FC = () => {
  const { values } = useContent();

  return (
    <section id="values">
      <div className="section-head">
        <div>
          <div className="eyebrow">{values.eyebrow}</div>
          <h2
            className="display-h2"
            style={{ marginTop: 14 }}
            dangerouslySetInnerHTML={{ __html: values.headingHtml }}
          />
        </div>
        <p style={{ maxWidth: 420 }} className="small">
          {values.intro}
        </p>
      </div>
      <div className="values-grid">
        {values.items.map((v, i) => (
          <Reveal key={v} delay={i * 60} className="value-card glass-soft">
            <span className="vc-num">{String(i + 1).padStart(2, '0')}</span>
            <span className="vc-name">{v}</span>
            <span className="vc-dot" />
          </Reveal>
        ))}
      </div>
    </section>
  );
};
